import Vue from "vue"
/* import couponsApi from "../../api/coupons" */
import utilsApi from "../../api/utils"

import { isUndefinedNullOrFalse } from "../../utils/equivalence"

const initialObject = {
  _id: undefined,
  name: undefined,
  code: undefined,
  discount_type: undefined,
  description: undefined,
  value: undefined,
  coupon: undefined,
  allow_free_shipping: undefined,
  expiration_date: undefined,
  exclude_products_selection: undefined,
  products_selection: undefined,
  product_collections_selection: undefined,
  exclude_product_collections_selection: undefined,
  exclude_emails_selection: undefined,
  emails_selection: undefined,
  usage_limit: undefined,
  limit_per_user: undefined,
  status: undefined,
  times_used: undefined,
  order_maximum_amount: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["times_used", "createdAt", "updatedAt"]
// general state for the site

const initialState = {
  coupons: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  coupons: (state) => state.coupons,
  couponsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] &&
              state[param][parent] &&
              !isUndefinedNullOrFalse(state[param][parent][key])
              ? state[param][parent][key]
              : undefined
            : state[param] && !isUndefinedNullOrFalse(state[param][key])
            ? state[param][key]
            : undefined
          : !isUndefinedNullOrFalse(state[param])
          ? state[param]
          : undefined
        : state
      : state
  },
  couponsError: (state) => state.error,
  coupons_Object: (state) => state.object,
  coupons_isNew: (state) => state.isNew,
  coupons_selected: (state) => state.selected
}
const actions = {
  async DELETE_coupons({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("coupons", object)
    if (apiResponse != null) {
      //commit("CUPONS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_coupons", state.page)
      //console.log("ESTADO DE PAGINA", state)
      return true
    } else {
      commit("CUPONS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_coupons({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_coupons", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_coupons", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_couponsState({ commit }, payload) {
    commit("SET_coupons", payload)
    return true
  },
  async UPDATE_coupons({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    //console.log("CAMPOS A GUARDAR CUPONES", filtered)
    let apiResponse = await utilsApi.updateObject("coupons", filtered)
    if (apiResponse != null) {
      commit("CUPONS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_coupons", state.page)
      return true
    } else {
      commit("CUPONS_ERROR")
      return false
    }
  },
  async CREATE_coupons({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("coupons", object)
    if (apiResponse != null) {
      commit("SET_coupons", {
        param: "object",
        value: apiResponse.coupon
      })

      dispatch("FETCH_PAGE_coupons", state.page)
      return true
    } else {
      commit("CUPONS_ERROR")
      return false
    }
  },
  async FETCH_coupons({ commit }) {
    let apiResponse = await utilsApi.getObjects("coupons")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("CUPONS_SETTING", apiResponse)
      return true
    } else {
      commit("CUPONS_ERROR")
      return false
    }
  },

  async FETCH_PAGE_coupons({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("coupons", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("CUPONS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("CUPONS_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_coupons({ commit }, payload) {
    commit("SET_OBJECT_COUPON", payload)
    return true
  },
  CLEAN_OBJECT_coupons({ commit }) {
    commit("SET_OBJECT_COUPON_INITIAL")
    return true
  },
  async CLEAN_STORE_coupons({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_coupons", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_coupons({ commit }, payload) {
    commit("SET_SELECTED_COUPONS", payload)
    return true
  }
}
const mutations = {
  CUPONS_SETTING: (state, { coupons, count = false, page }) => {
    //console.log(state)
    state.count = count || state.coupons.length
    state.page = page || state.page
    state.coupons = coupons
    state.fetched = true
    state.error = false
  },
  CUPONS_ERROR: (state) => {
    state.coupons = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_COUPON: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_COUPON_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_COUPONS: (state, selectedCoupons) => {
    state.selected = selectedCoupons
  },
  SET_coupons: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
